// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___35FCt","title":"styles__title___11hhF"};